module.exports = __webpack_public_path__ + "img/icon-ai-xiaojie-line@2x.1c953fe0.png";